import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
import store from '@/store';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: index
  },
  {
    path: '/OurStory',
    name: 'OurStory',
    component: () => import('../views/AboutUs/OurStory.vue')
  },
  {
    path: '/OurTeam',
    name: 'OurTeam',
    component: () => import('../views/AboutUs/OurTeam.vue')
  },
  {
    path: '/Collaborations',
    name: 'Collaborations',
    component: () => import('../views/AboutUs/Collaborations.vue')
  },
  {
    path: '/News',
    name: 'News',
    component: () => import('../views/AboutUs/News.vue')
  },
  {
    path: '/Vlog',
    name: 'Vlog',
    component: () => import('../views/AboutUs/Vlog.vue')
  },
  {
    path: '/News_details',
    name: 'News_details',
    component: () => import('../views/AboutUs/News_details.vue')
  },
  {
    path: '/Products_index',
    name: 'Products_index',
    component: () => import('../views/Products/index.vue')
  },
  {
    path: '/Products_details',
    name: 'Products_details',
    component: () => import('../views/Products/details.vue')
  },
  {
    path: '/Financial',
    name: 'Financial',
    component: () => import('../views/MemberCenter/Financial.vue')
  },
  {
    path: '/FinancialFinancialOpportunity',
    name: 'FinancialOpportunity',
    component: () => import('../views/MemberCenter/FinancialOpportunity.vue')
  },
  {
    path: '/FinancialRewards',
    name: 'FinancialRewards',
    component: () => import('../views/MemberCenter/FinancialRewards.vue')
  },
  {
    path: '/Contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },

  // { path: '/404', component: () => import('@/views/404'), name: '404', meta: { title: '404未找到' } },
  { path: '*', component: () => import('@/views/404'), name: '404', meta: { title: '404未找到' } },
]
const router = new VueRouter({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  },
  routes
})
router.beforeEach((to, from, next) => {
  let header_nav_list = store.state.common.header_nav_list ? store.state.common.header_nav_list : [];
  for (let i = 0; i < header_nav_list.length; i++) {
    if (to.fullPath == header_nav_list[i].url) {
			console.log(to, from,i,'1')
      store.state.video = header_nav_list[i].video_url;
      sessionStorage.setItem("video", header_nav_list[i].video_url)
      store.state.bannerS = header_nav_list[i].image_pc_url;
      sessionStorage.setItem("bannerS", header_nav_list[i].image_pc_url)
      break;
    } else {
      for (let j = 0; j < header_nav_list[i].sub_nav_list.length; j++) {
        if (to.fullPath == header_nav_list[i].sub_nav_list[j].url ) {
					console.log(to, from,i,'2')
          let video_url = header_nav_list[i].sub_nav_list[j].video_url
          let image_pc_url = header_nav_list[i].sub_nav_list[j].image_pc_url
          store.state.video = video_url;
          sessionStorage.setItem("video", video_url)
          store.state.bannerS = image_pc_url;
          sessionStorage.setItem("bannerS", image_pc_url)
          break;
        }
      }
    }
  }
  if (from.query.lang && !to.query.lang) {
    let query = '?lang=' + from.query.lang;
    for (let key in to.query) {
      query += "&" + key + "=" + to.query[key]
    }
    let path = to.path;
    let fullPath = to.path + query;
    query = to.query;
    query.lang = from.query.lang;
    next({ fullPath, path, query });
  } else {
    
  }
  // console.log(to.fullPath,from.fullPath)
  // if(to.name == 'Products_index' && from.name == 'Products_index'){
  //     if (from.query.lang && !to.query.lang) {
  //       let query = '?lang=' + from.query.lang;
  //       for (let key in to.query) {
  //         query += "&" + key + "=" + to.query[key]
  //       }
  //       window.location.href = to.path + query
  //     } else {
  //       window.location.href = to.fullPath
  //     }
  // }
  next();
})
export default router
